import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuiaCompleto from "../pages/artigo/guia-completo/page";
import ArtigoPage from "../pages/artigo/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artigo/guia-completo-hoobuy-spreadsheet",
    element: <GuiaCompleto />,
  },
  {
    path: "/artigo/:slug",
    element: <ArtigoPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;